/**
 * @fileoverview Main component.core
 */
'use strict';
// React Import
import React, { Component } from 'react';
import {
  BrowserRouter,
  Route,
  Link,
  Switch,
  Redirect,
  withRouter
} from 'react-router-dom';
import PropTypes from 'prop-types';
// Library Import
import _ from 'lodash';
import mobiscroll from '../../lib/mobiscroll/forms.react';
import { os } from '../../lib/mobiscroll/util/platform';
// Core Import
import Header from '../core/Header';
import Footer from '../core/Footer';
import Loading from '../core/Loading';
// Util Import
import * as ConstUtil from '../../util/ConstUtil';
import * as LogUtil from '../../util/LogUtil';

/**
 * Mainコンポーネント
 *
 * @class Main
 * @extends {Component}
 */
class Main extends Component {
  constructor(props) {
    super(props);
    LogUtil.d('Main Class constructor call');
    this.state = {
      component: <div />
    };
    this.headerHeight = 0;
    this.footerHeight = 0;
    // イベント処理に対してthisをbind
    _.bindAll(this, 'setHeaderHeight', 'setFoterHeight', 'getRefContent');
  }

  /**
   * Domツリー追加前イベント
   *
   * @memberof Main
   */
  componentWillMount() {
    this.props.history.listen((location, action) => {
      this.selectComponent(location.hash);
    });
  }

  /**
   * Domツリー追加後イベント
   *
   * @memberof Main
   */
  componentDidMount() {
    let hash = this.props.location.hash;
    // ログイン画面遷移
    if (_.isEmpty(hash)) {
      this.props.history.push(ConstUtil.Common.COMPONENT.LOGIN.URL);
      return;
    }
    this.props.history.push(hash);
  }

  /**
   * コンポーネント選択
   *
   * @param {String} hash hash
   * @returns
   * @memberof Main
   */
  async selectComponent(hash) {
    let componentUrl = hash;
    let index = hash.indexOf(
      ConstUtil.Common.QUERY_PARAMETER_KEY_LIST.QUESTION_MARK
    );
    // クエリパラメータが存在する場合
    if (index !== -1) {
      componentUrl = hash.replace(hash.slice(index), '');
    }
    // COMPONET一覧からhashと一致するものを取得する
    let component = _.find(ConstUtil.Common.COMPONENT, { URL: componentUrl });
    if (_.isEmpty(component)) {
      this.props.history.push(ConstUtil.Common.COMPONENT.LOGIN.URL);
      return;
    }
    // コンポーネントの動的インポート
    import('../' + component.PATH)
      .then(module => {
        // stateを更新しcontetとhelpを更新
        this.setState({ component: <module.default /> });
      })
      .catch(e => {
        return LogUtil.e(e);
      });
  }

  /**
   * ヘッダーの高さ設定
   *
   * @param {int} height 高さ
   * @memberof Main
   */
  setHeaderHeight(height) {
    this.headerHeight = height;
    this.changeContentStyle();
  }

  /**
   * フッターの高さ指定
   *
   * @param {int} height 高さ
   * @memberof Main
   */
  setFoterHeight(height) {
    this.footerHeight = height;
    this.changeContentStyle();
  }

  /**
   * contentのスタイル変更
   *
   * @memberof Main
   */
  changeContentStyle() {
    // 画面サイズの設定
    this.refContent.style.height = '100%';
    // サイズ調整判定用の高さ(Windowの高さから、ヘッダー・フッターを除外した高さ)
    const contentAreaHeight =
      window.innerHeight - this.headerHeight - this.footerHeight;
    // サイズ調整用の高さより、画面要素の高さが小さい場合
    if (this.refContent.offsetHeight < contentAreaHeight) {
      // 高さを100%(画面要素の高さ)からサイズ調整用の高さに拡大
      this.refContent.style.height = contentAreaHeight + 'px';
    }
    // Android と iOSの場合
    if (os === 'android' || os === 'ios') {
      this.refContent.style.marginBottom = this.footerHeight + 'px';
    }
  }

  /**
   * Contentの参照取得
   *
   * @param {Object} node ノード情報
   * @returns
   * @memberof Main
   */
  getRefContent(node) {
    if (_.isEmpty(node)) {
      return;
    }
    this.refContent = node;
  }

  /**
   * 描画
   *
   * @returns Main
   * @memberof Main
   */
  render() {
    // スクロール位置ををトップにセット
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
    // スマホ対応
    let mobile = '';
    // Android と iOSの場合
    if (os === 'android' || os === 'ios') {
      mobile = 'mobile';
    }
    return (
      <div id="main" className={`${os} ${mobile} `}>
        {Loading.getElement()}
        <mobiscroll.Form
          noValidate
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
        >
          <Header setHeight={this.setHeaderHeight} />
          <div id="content" ref={this.getRefContent}>
            {this.state.component}
          </div>
          <Footer setHeight={this.setFoterHeight} />
        </mobiscroll.Form>
      </div>
    );
  }
}
Main.propTypes = {
  location: PropTypes.shape({ hash: PropTypes.string.isRequired }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    listen: PropTypes.func.isRequired
  })
};
export default withRouter(Main);



// WEBPACK FOOTER //
// ./src/js/component/core/Main.jsx